import React from "react";

function Info() {
  return (
    <div className="section-audio">
      <div className="audio-info">
        <div className="audio-text">
          <h4>
            Bringing you the <span>best</span> audio gear
          </h4>
          <p>
            Located at the heart of New York City, Audiophile is the premier
            store for high end headphones, earphones, speakers, and audio
            accessories. We have a large showroom and luxury demonstration rooms
            available for you to browse and experience a wide range of our
            products. Stop by our store to meet some of the fantastic people who
            make Audiophile the best place to buy your portable audio equipment.
          </p>
        </div>
        <div className="audio-img">
          <img className="audio-desktop" src="../Images/Bitmap (3).png" alt="" />
          <img className="audio-none" src="../Images/Bitmap (4).png" alt="" />
          <img className="mobile-audio" src="../Images/Bitmap (10).png" alt="" />
        </div>
      </div>
    </div>
  );
}

export default Info;
